export const useProvider = {
  FAKE: 'TCS by OSP',
  TCS: 'TCS',
  'SUISSE-PASS': 'Suisse Pass',
  SKIDATA: 'Skidata Keycard',
  TCSOSP: 'TCS by OSP',
};
